module.exports = __webpack_public_path__ + "assets/img/126af061f9ba83a1a67c8564c376998c.png";